export const LOAD_BALANCE = 'LOAD_BALANCE';
export const LOAD_BALANCE_SUCCESS = `${LOAD_BALANCE}_SUCCESS`;
export const LOAD_BALANCE_FAIL = `${LOAD_BALANCE}_FAIL`;
export const LOAD_BALANCE_CACHED = 'LOAD_BALANCE_CACHED';
export const LOAD_BALANCE_CACHED_SUCCESS = `${LOAD_BALANCE_CACHED}_SUCCESS`;
export const LOAD_BALANCE_CACHED_FAIL = `${LOAD_BALANCE_CACHED}_FAIL`;
export const BALANCE_SHOW_HIDE = `BALANCE_SHOW_HIDE`;

const BalanceReducer = (state = { isLoading: false, pointsValue: 0, hidePoints:false}, action = {}) => {
  switch (action.type) {
    case BALANCE_SHOW_HIDE:
      return { ...state, hidePoints: action.payload.hidePoints };
    case LOAD_BALANCE:
      return { ...state, isLoading: true };
    case LOAD_BALANCE_SUCCESS:
      return { ...state, isLoading: false, ...action.payload.data };
    case LOAD_BALANCE_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error.data,
        statusCode: action.error.response.status,
      };
    case LOAD_BALANCE_CACHED_SUCCESS:
      return { ...state, isLoading: false, pointsValue: action.payload.data };
    case LOAD_BALANCE_CACHED_FAIL:
      return { ...state, isLoading: false, error: action.error.data };
    default:
      return { ...state };
  }
};

export default BalanceReducer;
